import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/Common";
import { ARTICLES, GUIDE_CATS, IMG } from "../mock";
import { useReveal } from "../lib/lang";

export const ArticleCard = ({ a }) => (
  <Link to={`/corfu-guide/${a.slug}`} className="reveal lift group bg-white rounded-2xl overflow-hidden border border-[#183C35]/10 flex flex-col" data-testid="article-card">
    <div className="h-40 sm:h-52 overflow-hidden"><img src={a.image.replace("w=2000", "w=1200")} srcSet={`${a.image.replace("w=2000", "w=700")} 700w, ${a.image.replace("w=2000", "w=1200")} 1200w`} sizes="(max-width: 640px) 100vw, 33vw" loading="lazy" alt={`${a.title} – Corfu travel guide by Aloha Corfu Transfers`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
    <div className="p-4 sm:p-6 flex flex-col flex-1">
      <p className="flex items-center gap-3 text-[12.5px]"><span className="rounded-full bg-[#E4EFF0] text-[#3E7F8E] px-2.5 py-0.5 font-medium">{a.cat}</span><span className="text-[#202522]/55">2026-10-05</span></p>
      <h3 className="font-serif-d text-[19px] sm:text-[22px] font-semibold text-[#183C35] mt-2 sm:mt-3 leading-snug">{a.title}</h3>
      <p className="mt-2.5 text-[15px] leading-relaxed text-[#202522]/70 flex-1">{a.excerpt}</p>
      <span className="mt-5 inline-flex items-center gap-1.5 text-[15px] font-medium text-[#3E7F8E]">Read more <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
    </div>
  </Link>
);

const Guide = () => {
  const [cat, setCat] = useState("All");
  useReveal();
  const list = cat === "All" ? ARTICLES : ARTICLES.filter((a) => a.cat === cat);
  return (
    <div data-testid="guide-page">
      <PageHero image={IMG.westCoast} eyebrow="Corfu guide" title="Travel smarter in Corfu" sub="Local, practical advice to help you plan the perfect Corfu holiday." />
      <section className="py-10 sm:py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-2 overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap [scrollbar-width:none]">
            {GUIDE_CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`guide-cat-${c.replace(/\s/g, "-").toLowerCase()}`}
                className={`shrink-0 rounded-full px-4 py-2 text-[13.5px] sm:text-[14.5px] border transition-colors duration-200 ${cat === c ? "bg-[#183C35] text-[#F7F3EA] border-[#183C35]" : "bg-white text-[#202522]/75 border-[#183C35]/15 hover:border-[#183C35]/40"}`}>{c}</button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-10" key={cat}>
            {list.map((a) => <ArticleCard key={a.slug} a={a} />)}
          </div>
          {list.length === 0 && <p className="mt-10 text-[#202522]/60">No articles in this category yet.</p>}
        </div>
      </section>
    </div>
  );
};

export default Guide;
